import { CardRiskClassification } from 'components/CardRiskClassification';
import { CardSymptom } from 'components/CardSymptom';
import { RiskClassificationLegend } from 'components/RiskClassificationLegend';
import { ITreatmentOnGoing } from 'types';

import { Box, Grid, Stack, Typography } from '@mui/material';

type Props = Pick<ITreatmentOnGoing, 'generalClassification' | 'symptoms'>;

export const PetSymptoms: React.FC<Props> = ({
  symptoms,
  generalClassification,
}) => {
  if (!symptoms?.length && !generalClassification) {
    return null;
  }

  return (
    <>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="flex-start"
        spacing={2}
      >
        <Stack spacing={1}>
          <Typography sx={{ color: '#4B4B4B', fontSize: 14 }}>
            Classificado como
          </Typography>

          <Box
            px={4}
            borderRadius={1}
            border="1px solid #FBB45F"
            overflow="hidden"
          >
            <CardRiskClassification classification={generalClassification} />
          </Box>
        </Stack>

        <Stack spacing={0.5}>
          <Typography sx={{ color: '#4B4B4B', fontSize: 14 }}>
            Sintomas
          </Typography>

          <Grid
            container
            spacing={1}
            direction="row"
            alignSelf="self-end"
            alignItems="flex-start"
            justifyContent="flex-start"
          >
            {symptoms.length === 0 ? (
              <Grid item>
                <CardSymptom
                  title="Não foi selecionado nenhum sintoma"
                  classification="ROUTINE_CONSULTATION"
                />
              </Grid>
            ) : (
              symptoms.map(({ name, classification }) => {
                return (
                  <Grid item key={name}>
                    <CardSymptom title={name} classification={classification} />
                  </Grid>
                );
              })
            )}
          </Grid>
        </Stack>
      </Stack>

      <RiskClassificationLegend />
    </>
  );
};
